<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" align="center" :formdata="getBase" :value="formData"></compFormQuery>
			<compFormEdit v-else ref="relation" align="center" class="margin-layout" :formdata="getBase" v-model="formData"/>
		</compWrapper>
		<compWrapper :title="$t('global.log.name',{defaultValue:'操作历史'})" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
		<div class="text-right">
			<vButton v-if="!query" theme="primary" class="width-15per" @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</vButton>
            <vButton class="width-15per margin-left-10" @click="cancel">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpGetDisCountOne, HttpSaveDisCountOne, HttpGetLog } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';

export default {
	mixins:[mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			formData: {
			}
		}
	},
	created() {
		this.query = this.type === "query";
		this.getDetail()
	},
	computed: {
		...mapGetters('dictionary', ['getCarrierServiceAllList']),
		getBase() {
			let showquery = this.type == 'edit' || this.type == 'query'
			return [
				{
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
					key: "account",
					query:showquery,
                },
                {
					label: this.$t('erp.product_channel.type',{defaultValue:'类型'}),
					key: "discountType",
					tag:'vSelect',
					options:[
						{ value: 'ACCOUNT', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}) },
                		{ value: 'ACCOUNT_SERVICE', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}) },
						{ value: 'ACCOUNT_SERVICE_WEIGHT', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})+'+'+this.$t('global.common.weight',{defaultValue:'重量'}) },
					],
					query:showquery,
				},
				{
					// label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: '承运商服务',
					key: "carrierServiceCode",
					tag:'vSelect',
					options: this.getCarrierServiceAllList.map(item=>{
						return {
							value:item.attach.carrierServiceCode,
							label:item.attach.carrierServiceCode
						}
					}),
					show:this.type=='add' && (this.formData.discountType == 'ACCOUNT_SERVICE' || this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT'),
					props: {
						filterable: true,
					}
				},
				{
					label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
					valueText:`${this.formData.carrierCode} (${this.formData.carrierServiceCode})`,
					show:showquery && (this.formData.discountType == 'ACCOUNT_SERVICE' || this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT'),
					query:showquery,
				},
				{
                    label: "重量区间最小值",
                    key: "weightRangeMin",
					tag:'vInput',
					show:this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT' && (this.type=='add' || this.type=='edit'),
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">lbs</span>
					},
				},
				{
					label:this.$t('fbb.account.cusdisacountrate_weight_min',{defaultValue:'重量区间最小值'}),
					valueText:`${this.formData.weightRangeMin} lbs`,
					show:this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT' && this.type=='query',
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'}),
					tag:'vInput',
					key: "weightRangeMax",
					show:this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT' && (this.type=='add' || this.type=='edit'),
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">lbs</span>
					},
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'}),
					valueText:`${this.formData.weightRangeMax} lbs`,
					show:this.formData.discountType == 'ACCOUNT_SERVICE_WEIGHT' && this.type=='query',
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_rate ',{defaultValue:'折扣率'}),
					tag:'vInput',
					key: "discount",
				},

			];
		},
	},
	methods: {
		async getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
            HttpGetDisCountOne({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});
			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:25,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{

				})
			}
		},
		handleResponse(data={}){
			this.formData = data
		},
		async submit(){
			const valid = await this.$refs['relation'].validate();
			if (!valid) return;

			if(this.formData.carrierServiceCode){
				let oneitem;
				this.getCarrierServiceAllList.forEach(item => {
					// console.log(item)
					if(this.formData.carrierServiceCode == item.attach.carrierServiceCode){
						oneitem = item
					}
				});
				// console.log(oneitem)
				this.formData.carrierCode = oneitem.attach.carrierCode
			}

			this.loading = true
			HttpSaveDisCountOne({
				id:this.id,
				...this.formData,
				contextId:global.SYSID
			}).then(res=>{
				this.$VMessage.success(res.message);
				this.cancel()
			},err=>{
				this.$VMessage.error(err.message);
			}).finally(res=>{
				this.loading = false
			})
		},
		cancel(){
			this.$router.push({ name: "fedexDiscount" })
		}
	},
}
</script>
